import React, { Component } from 'react';
import { injectIntl } from 'react-intl';
import { compose } from 'react-apollo';
import { DropTarget } from 'react-dnd';
import classnames from 'classnames';

import TextField from 'material-ui/TextField';
import AutoComplete from 'material-ui/AutoComplete';
import DeleteIcon from 'material-ui/svg-icons/navigation/cancel';

import PaperForm from '../PaperForm';

import styles from './ParticipantForm.css';

const nonEditableStyle = { cursor: 'auto' };
const nonEditableInputStyle = { color: 'rgba(0, 0, 0, 0.87)' };
const underlineDisabledStyle = {
    borderBottom: '1px solid rgb(224, 224, 224)',
};

const autoCompleteStyle = { width: 'auto' };

class ParticipantForm extends Component {
    state = {
        errors: {
            name: '',
            school: '',
            grade: '',
            email: '',
        },
        genders: [],
    };

    componentDidMount() {
        const {
            intl: { formatMessage },
        } = this.props;

        this.setState({
            genders: [formatMessage({ id: 'EnterData.gender.m' }), formatMessage({ id: 'EnterData.gender.f' })],
        });
    }

    componentWillUnmount() {
        document.removeEventListener('mousedown', this.handleClickOutside);
    }

    handleFocus = () => {
        document.addEventListener('mousedown', this.handleClickOutside);
    };

    handleClickOutside = event => {
        const {
            participant: { name, grade, school },
            onFocusOut,
            intl: { formatMessage },
        } = this.props;

        if (this.ref && !this.ref.contains(event.target)) {
            document.removeEventListener('mousedown', this.handleClickOutside);
            onFocusOut();

            let errors = {};

            if (!name) errors.name = formatMessage({ id: 'EnterData.required' });
            if (!grade) errors.grade = formatMessage({ id: 'EnterData.required' });
            if (!school) errors.school = formatMessage({ id: 'EnterData.required' });

            if (Object.keys(errors)) {
                this.setState({ errors });
            }
        }
    };

    handleNameChange = (e, name) => {
        this.props.onParticipantChange(this.props.index, 'name', name);

        if (this.state.errors.name) {
            this.setState({ errors: { ...this.state.errors, name: '' } });
        }
    };

    handleGenderChange = gender => {
        this.props.onParticipantChange(this.props.index, 'gender', gender);
    };

    handleGradeChange = (e, grade) => {
        grade = grade.replace(/\D/g, '');

        if (grade !== '') {
            grade = parseInt(grade, 10);
        }

        this.props.onParticipantChange(this.props.index, 'grade', grade);

        if (this.state.errors.grade) {
            this.setState({ errors: { ...this.state.errors, grade: '' } });
        }
    };

    handleSchoolChange = (e, school) => {
        this.props.onParticipantChange(this.props.index, 'school', school);

        if (this.state.errors.school) {
            this.setState({ errors: { ...this.state.errors, school: '' } });
        }
    };

    handleEmailChange = (e, email) => {
        this.props.onParticipantChange(this.props.index, 'email', email);
    };

    handlePaperChange = (index, field, value) => {
        this.props.onParticipantPaperChange(this.props.index, index, field, value);
    };

    handleDeleteClick = () => {
        this.props.onParticipantDelete(this.props.index);
    };

    handlePaperDelete = paperIndex => {
        this.props.onParticipantPaperDelete(this.props.index, paperIndex);
    };

    handlePaperOpenClick = paperIndex => {
        this.props.onPaperOpenClick(this.props.index, paperIndex);
    };

    render() {
        const {
            participant,
            intl: { formatMessage },
            connectDropTarget,
            index,
            isOver,
            editable,
            onParticipantDelete,
            season,
        } = this.props;
        const { errors } = this.state;

        return connectDropTarget(
            <div ref={ref => (this.ref = ref)} className={classnames(styles.participant, { [styles.isOver]: isOver })}>
                {onParticipantDelete &&
                    editable && <DeleteIcon className={styles.deleteButton} onClick={this.handleDeleteClick} />}
                <TextField
                    value={participant.name}
                    floatingLabelText={formatMessage({ id: 'EnterData.name' }) + '*'}
                    floatingLabelFixed={true}
                    onChange={this.handleNameChange}
                    className={styles.name}
                    errorText={errors.name}
                    errorStyle={{ float: 'left' }}
                    disabled={!editable}
                    underlineDisabledStyle={underlineDisabledStyle}
                    style={!editable ? nonEditableStyle : undefined}
                    inputStyle={!editable ? nonEditableInputStyle : undefined}
                    onFocus={this.handleFocus}
                />
                <AutoComplete
                    searchText={participant.gender}
                    dataSource={this.state.genders}
                    filter={AutoComplete.noFilter}
                    onUpdateInput={this.handleGenderChange}
                    floatingLabelText={formatMessage({ id: 'EnterData.gender' })}
                    floatingLabelFixed={true}
                    className={styles.gender}
                    openOnFocus
                    errorText={errors.gender}
                    errorStyle={{ float: 'left' }}
                    disabled={!editable}
                    underlineDisabledStyle={underlineDisabledStyle}
                    style={autoCompleteStyle}
                    textFieldStyle={!editable ? nonEditableStyle : undefined}
                    inputStyle={!editable ? nonEditableInputStyle : undefined}
                />
                <TextField
                    value={participant.grade}
                    floatingLabelText={formatMessage({ id: 'EnterData.grade' }) + '*'}
                    floatingLabelFixed={true}
                    onChange={this.handleGradeChange}
                    className={styles.grade}
                    errorText={errors.grade}
                    errorStyle={{ float: 'left' }}
                    disabled={!editable}
                    underlineDisabledStyle={underlineDisabledStyle}
                    style={!editable ? nonEditableStyle : undefined}
                    inputStyle={!editable ? nonEditableInputStyle : undefined}
                    onFocus={this.handleFocus}
                />
                <TextField
                    value={participant.school}
                    floatingLabelText={formatMessage({ id: 'EnterData.school' }) + '*'}
                    floatingLabelFixed={true}
                    onChange={this.handleSchoolChange}
                    className={styles.school}
                    errorText={errors.school}
                    errorStyle={{ float: 'left' }}
                    disabled={!editable}
                    underlineDisabledStyle={underlineDisabledStyle}
                    style={!editable ? nonEditableStyle : undefined}
                    inputStyle={!editable ? nonEditableInputStyle : undefined}
                />
                <TextField
                    value={participant.email}
                    floatingLabelText={formatMessage({ id: 'EnterData.email' })}
                    floatingLabelFixed={true}
                    onChange={this.handleEmailChange}
                    className={styles.email}
                    errorText={errors.email}
                    errorStyle={{ float: 'left' }}
                    disabled={!editable}
                    underlineDisabledStyle={underlineDisabledStyle}
                    style={!editable ? nonEditableStyle : undefined}
                    inputStyle={!editable ? nonEditableInputStyle : undefined}
                />
                <div>
                    {participant.papers.map((paper, paperIndex) => (
                        <PaperForm
                            key={paper.file}
                            paper={paper}
                            participantIndex={index}
                            index={paperIndex}
                            onPaperChange={this.handlePaperChange}
                            onDelete={this.handlePaperDelete}
                            onOpenClick={this.handlePaperOpenClick}
                            editable={editable}
                            season={season}
                        />
                    ))}
                </div>
            </div>
        );
    }
}

export default compose(
    injectIntl,
    DropTarget(
        'paper',
        {
            drop: (props, monitor) => {
                const { paper, participantIndex: fromIndex } = monitor.getItem();
                props.onPaperDrop(props.index, fromIndex, paper);
            },
        },
        (connect, monitor) => ({
            connectDropTarget: connect.dropTarget(),
            isOver: monitor.isOver() && monitor.getItemType() === 'paper',
        })
    )
)(ParticipantForm);



// WEBPACK FOOTER //
// ./src/Components/ParticipantForm/ParticipantForm.js